export default "__VITE_ASSET__123672d0__"